import { render } from "./SportClubView.vue?vue&type=template&id=77a991ee"
import script from "./SportClubView.vue?vue&type=script&lang=js"
export * from "./SportClubView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__